import { createStore } from 'vuex'
import { isMiniProgram } from '@/utils/index'
import request from '@/utils/request'
import urls from '@/api/urls'

let channel = 'h5'
if (hcApp.isHCApp()) {
  channel = 'app'
} else if (/miniprogram/.test(navigator.userAgent.toLowerCase())) {
  channel = 'applet'
}

const store = createStore({
  state: {
    pageLoading: false, // 页面loading
    userInfo: {}, // 用户信息
    keyboardUp: false, // 键盘是否弹起
    collectEventChannel: channel, // 数据埋点用
  },
  mutations: {
    hidePageLoading(state) {
      state.pageLoading = false
    },
    showPageLoading(state) {
      state.pageLoading = true
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo

      // 小程序内嵌页，埋点系统需要设置user_unique_id
      if (userInfo.userId) {
        window.collectEvent('config', {
          user_unique_id: userInfo.userId, // 设置唯一用户ID
        })
      }
    },
    setKeyboardUp(state, keyboardUp) {
      state.keyboardUp = keyboardUp
    },
  },
  actions: {
    getUserInfo({ commit }) {
      const query = {}
      const queryStr = location.href.split('?')[1] || ''
      queryStr.split('&').forEach((item) => {
        const [key, value] = item.split('=')
        query[key] = value
      })
      return new Promise((resolve, reject) => {
        isMiniProgram().then(async (result) => {
          if (result) {
            if (query.gkToken && query.unionId) {
              const res = await request({
                method: 'post',
                url: urls.queryUserInfo,
                headers: { ha_acp_token: query.gkToken },
                data: {},
              })
              const userInfo = {
                acpToken: query.gkToken,
                openId: query.openId,
                userId: res.encryptedUserId,
                loaded: true,
              }
              commit('setUserInfo', userInfo)
              localStorage.setItem('userInfo', JSON.stringify(userInfo))
              resolve(userInfo)
            } else {
              const userInfo = localStorage.getItem('userInfo')
              if (userInfo) {
                commit('setUserInfo', { ...JSON.parse(userInfo), loaded: true })
                resolve(userInfo)
              } else {
                commit('setUserInfo', { loaded: true })
                resolve({ loaded: true })
              }
            }
          } else {
            const userInfo = localStorage.getItem('userInfo')
            if (userInfo) {
              commit('setUserInfo', { ...JSON.parse(userInfo), loaded: true })
              resolve(userInfo)
            }
            hcApp
              .postMessage({
                methodName: 'getUserInfo',
              })
              .then((res) => {
                if (res.acpToken) {
                  commit('setUserInfo', { ...res, loaded: true })
                } else {
                  commit('setUserInfo', {
                    loaded: true,
                  })
                }
                resolve(res)
              })
          }
        })
      })
    },
  },
})
export default store
